import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { AppService } from './services/app.service';
import { HttpClient } from '@angular/common/http';
import { PrimeNGConfig } from 'primeng/api';
import { KeycloakService } from 'keycloak-angular';
import { DataService } from './services/data.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from './services/translate.service';
import { HttpConfig } from './configs/http.config';
import { loadingConfig } from './configs/loading.config';
import { LoadingService } from './services/loading.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  side: boolean = false;
  checkWidth: number = 0;


  constructor(private _auth: AuthService,
    public app: AppService,
    private primengConfig: PrimeNGConfig,
    private kc: KeycloakService,
    private ds: DataService,
    public tn: TranslateService,
    private http: HttpClient) {


    this.tn.getTranslate()
    this.checkWidth = window.outerWidth;
    setTimeout(() => {
      if (!sessionStorage.getItem('ogid')) {
        // window.location.replace('https://dashboard.legitid.org/check?system=' + window.location.origin)
        // window.location.replace('http://localhost:4200/check?system=' + window.location.origin)
      }
    }, 1500)



    this.ds.ogId = (<any>sessionStorage.getItem('ogid'))
    this.ds.realmid = (<any>sessionStorage.getItem('realmid'))
    this.ds.menuId = (<any>sessionStorage.getItem('menuid'))
    this.ds.branchId = (<any>sessionStorage.getItem('branchId'))
    this.ds.logo = (<any>sessionStorage.getItem('logo'))
    this.ds.code = (<any>sessionStorage.getItem('code'))
    this.ds.license = (<any>sessionStorage.getItem('license'))
  }
  ngOnInit() {
    this.primengConfig.ripple = true;
    this.getUser();
  }

  getDefault() {
    this.http.get('default/check').subscribe({
      next: (res: any) => {
      }
    })
  }

  getUser() {
    this.kc.getToken().then((token: any) => {
      this._auth.access_token = token
      this.getDefault();
    })
  }

  show: number = 0
  @HostListener('click', ['$event.target'])
  onClick(event: any) {
    this.show++
    if (this.show > 1) {
      this.app.contactAction = false;
      this.show = 0
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWidth = event.target.outerWidth;
  }

  action() {
    this.app.menuAction = !this.app.menuAction
  }

  toBack() {
    this.ds.menuId = ""
    this.ds.branchId = ""
    this.ds.ogId = ""
    this.ds.license = ""
    sessionStorage.removeItem('ogid')
    sessionStorage.removeItem('license')
    // window.location.replace(environment.replaceUrl + '/check?system=' + window.location.origin)
    window.location.replace(`${environment.replaceUrl}/check/${environment.keySystem}?system=${window.location.origin + environment.pathURL}`)
  }

  buyPackage() {
    window.location.replace(`${environment.replaceUrl}/onside-package/${environment.keySystem}/${this.ds.ogId}`)
  }

  UseLicense() {
    if (this.ds.ogId) window.location.replace(`${environment.replaceUrl}/active-licesne/${environment.keySystem}/${this.ds.ogId}`)
  }
}
